module.exports = __webpack_public_path__ + "img/pelota_boton3.cf9390f4.gif";